import { useMemo } from 'react';
import { useCompanyList } from '../../../hooks/company/useCompanyList.js';
import CompanyTable from '../../../components/tables/company/CompanyTable.jsx';
import SearchBar from '../../../components/utils/SearchBar.jsx';
import Pagination from '../../../components/utils/Pagination.jsx';
import SuccessModal from '../../../components/modales/SuccessModal.jsx';
import ErrorModal from '../../../components/modales/ErrorModal.jsx';
import DeleteModal from '../../../components/modales/DeleteModal.jsx';

export default function ListCompany() {
    const {
        companies,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        companyToDelete,
        setCompanyToDelete,
        confirmDelete,
        success,
        setSuccess,
        error,
        setError,
        handleSort,
        sortField,
        sortOrder   
    } = useCompanyList();

    // FILTRO POR BÚSQUEDA
    const filteredCompanies = useMemo(() => {
        const search = searchTerm.toLowerCase();

        return companies.filter(company => {
            return (
                (company.name || '').toLowerCase().includes(search) ||
                (company.shortname || '').toLowerCase().includes(search)
            );
        });
    }, [companies, searchTerm]);

    // PAGINACIÓN
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentCompanies = filteredCompanies.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <>
            <div className='container-fluid mt-6'>
                <h1 className='text-center mt-5 mb-5'><i className="bi bi-buildings me-4"></i> Lista de empresas</h1>
                <SearchBar 
                    searchTerm={searchTerm} 
                    handleSearchChange={e => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(1);
                    }}
                />

                <CompanyTable
                    companies={currentCompanies}
                    currentPage={currentPage}
                    itemsPerPage={itemsPerPage}
                    handleSort={handleSort}
                    sortField={sortField}
                    sortOrder={sortOrder}
                    onDelete={setCompanyToDelete}
                />

                <Pagination
                    itemsPerPage={itemsPerPage}
                    totalItems={filteredCompanies.length}
                    currentPage={currentPage}
                    paginate={setCurrentPage}
                />
                <DeleteModal 
                    show={!!companyToDelete}
                    message={"¿Realmente deseas eliminar este registro? Este proceso no se puede deshacer."}
                    fundelete={confirmDelete}
                    onClose={() => setCompanyToDelete(null)}
                />
                <SuccessModal show={!!success} message={success} onClose={() => setSuccess('')} />
                <ErrorModal show={!!error} message={error} onClose={() => setError('')} />
            </div>
        </>
    );
}